import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import RequirementPage from './RequirementPage';

/**
 * Broker In A Suit - Brand Launch
 * Founder: Shrimuk Lalitkanth Mamaidi
 * Location: Pune, India
 */

const root = ReactDOM.createRoot(document.getElementById('root'));

// Two plain sub pages, picked by path. Vercel sends every path to index.html.
const path = window.location.pathname.replace(/\/+$/, '');
const page = path === '/for-clients' ? <RequirementPage form="client" />
  : path === '/for-brokers' ? <RequirementPage form="broker" />
  : <App />;

root.render(
  <React.StrictMode>
    {page}
  </React.StrictMode>
);

// Performance monitoring (optional)
// If you want to measure load times for the premium experience, 
// you can pass a function to log results (e.g. reportWebVitals(console.log))